<app-ice-visuals-dashboard-line-chart [labels]="chartLabels()" [series]="chartSeries()" [loading]="dataService.loading()" />
